import { createElementVNode as _createElementVNode, resolveComponent as _resolveComponent, createVNode as _createVNode, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, toDisplayString as _toDisplayString, createTextVNode as _createTextVNode, resolveDynamicComponent as _resolveDynamicComponent, normalizeClass as _normalizeClass, createBlock as _createBlock } from "vue"

const _hoisted_1 = { class: "grid grid-cols-12 gap-3" }
const _hoisted_2 = { class: "col-span-12 xxl:col-span-12 grid grid-cols-12 gap-3" }
const _hoisted_3 = { class: "col-span-12 mt-4" }
const _hoisted_4 = { class: "intro-y flex items-center h-10" }
const _hoisted_5 = /*#__PURE__*/_createElementVNode("h2", { class: "text-lg font-medium truncate mr-5" }, "Dashboard Tentor", -1)
const _hoisted_6 = { class: "ml-auto mt-2 sm:mt-0 flex flex-row items-center" }
const _hoisted_7 = /*#__PURE__*/_createElementVNode("span", { class: "hidden md:block" }, "Reload Data", -1)
const _hoisted_8 = { class: "col-span-12 grid grid-cols-12 gap-3 mt-3 intro-y w-full" }
const _hoisted_9 = { class: "report-box zoom-in" }
const _hoisted_10 = { class: "box p-5" }
const _hoisted_11 = { class: "flex items-center" }
const _hoisted_12 = { class: "text-base font-medium mr-2" }
const _hoisted_13 = /*#__PURE__*/_createElementVNode("br", null, null, -1)
const _hoisted_14 = { class: "ml-auto" }

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_RefreshCcwIcon = _resolveComponent("RefreshCcwIcon")!
  const _component_LoadingDiv = _resolveComponent("LoadingDiv")!

  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createElementVNode("div", _hoisted_2, [
      _createElementVNode("div", _hoisted_3, [
        _createElementVNode("div", _hoisted_4, [
          _hoisted_5,
          _createElementVNode("div", _hoisted_6, [
            _createElementVNode("button", {
              onClick: _cache[0] || (_cache[0] = ($event: any) => (_ctx.getData())),
              class: "button bg-theme-1 hover:bg-primary text-white flex"
            }, [
              _createVNode(_component_RefreshCcwIcon, { class: "w-4 h-4 mr-0 md:mr-2" }),
              _hoisted_7
            ])
          ])
        ])
      ]),
      _createVNode(_component_LoadingDiv, { id: "loadingDT" }),
      _createElementVNode("div", _hoisted_8, [
        (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.dataDB.data, (ds, idx) => {
          return (_openBlock(), _createElementBlock("div", {
            key: idx,
            class: "col-span-12 sm:col-span-6 xl:col-span-4 xxl:col-span-3 intro-y mb-3"
          }, [
            _createElementVNode("div", _hoisted_9, [
              _createElementVNode("div", _hoisted_10, [
                _createElementVNode("div", _hoisted_11, [
                  _createElementVNode("p", _hoisted_12, [
                    _createTextVNode(_toDisplayString(ds.title) + " : ", 1),
                    _hoisted_13,
                    _createTextVNode(" " + _toDisplayString(_ctx.$gpf.convertToCurrency(ds.value, ds.prefix + " ")), 1)
                  ]),
                  _createElementVNode("div", _hoisted_14, [
                    (_openBlock(), _createBlock(_resolveDynamicComponent(ds.icon), {
                      class: _normalizeClass('w-10 h-10 ' + _ctx.$gpf.getRT())
                    }, null, 8, ["class"]))
                  ])
                ])
              ])
            ])
          ]))
        }), 128))
      ])
    ])
  ]))
}